import { AddDocument, Chatroom, Chats, DatasetList, Home, Setting, SignIn, EditDataset, OrganizationUserList, SignUp, ForgetPassword } from "pages";
import { RouteType } from "types/route";
import OrganizationList from "./Organization/OrganizationList";

const routes: RouteType[] = [
	{
		path: "signin",
		renderer: (params = {}): JSX.Element => <SignIn {...params} />,
	},
	{
		path: "signup",
		renderer: (params = {}): JSX.Element => <SignUp {...params} />,
		type: "unauth",
	},
	{
		path: "forget-password",
		renderer: (params = {}): JSX.Element => <ForgetPassword {...params} />,
		type: "unauth",
	},
	{
		path: "",
		renderer: (params = {}): JSX.Element => <Home {...params} />,
		type: "auth",
	},
	{
		path: "chat/:id?",
		renderer: (params = {}): JSX.Element => <Chatroom {...params} />,
		type: "auth",
	},
	{
		path: "chats",
		renderer: (params = {}): JSX.Element => <Chats {...params} />,
		type: "auth",
	},
	{
		path: "document/add/:id",
		renderer: (params = {}): JSX.Element => <AddDocument {...params} />,
		type: "auth",
	},
	{
		path: "dataset/list",
		renderer: (params = {}): JSX.Element => <DatasetList {...params} />,
		type: "auth",
	},
	{
		path: "/app/dataset/edit/:id?",
		renderer: (params = {}): JSX.Element => <EditDataset {...params} />,
		type: "auth",
	},
	{
		path: "organization/list",
		renderer: (params = {}): JSX.Element => <OrganizationList {...params} />,
		type: "auth",
	},
	{
		path: "organization/userList/:id",
		renderer: (params = {}): JSX.Element => <OrganizationUserList {...params} />,
		type: "auth",
	},
	{
		path: "setting",
		renderer: (params = {}): JSX.Element => <Setting {...params} />,
		type: "auth",
	},
];

export default routes;
